import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormGroup, FormText, Label, Input } from "reactstrap";
import TextareaAutosize from "react-textarea-autosize";

class inputComponent extends Component {
  getValidationState = () => {
    const { isInvalid, isValid, isWarning, isEmpty } = this.props;
    let classNameValidity = isInvalid ? "is-invalid" : "";
    classNameValidity = isValid ? "is-valid" : classNameValidity;
    classNameValidity = isWarning ? "warning" : classNameValidity;
    classNameValidity = isEmpty ? "empty" : classNameValidity;

    return classNameValidity;
  };

  render() {
    const {
      isInvalid,
      name,
      message,
      placeholder,
      label,
      value,
      onChange,
      className,
      helpText,
      type,
      isWarning,
      isEmpty,
      disabled
    } = this.props;

    return (
      <FormGroup>
        <Label className={className}>{label}</Label>
        {type === "textarea" ? (
          <TextareaAutosize
            name={name}
            className={`${this.getValidationState()} ${className}`}
            ref={name}
            value={value}
            onChange={onChange}
          />
        ) : (
          <Input
            type={type}
            name={name}
            className={`${this.getValidationState()} ${className}`}
            placeholder={placeholder}
            ref={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        )}
        <small className={isWarning ? "warning" : "d-none"}>
          Warning - The translation is the same as the base language
        </small>
        <small className={isEmpty ? "empty" : "d-none"}>Translation missing</small>
        <FormText color="muted">{helpText}</FormText>

        {isInvalid && message ? <FormText className="text-danger">{message}</FormText> : null}
      </FormGroup>
    );
  }
}

inputComponent.defaultProps = {
  placeholder: "",
  isValid: false,
  isInvalid: false,
  isEmpty: false,
  isWarning: false,
  disabled: false,
  message: "",
  value: "",
  className: "",
  helpText: "",
  type: "textarea"
};

inputComponent.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  message: PropTypes.string,
  isInvalid: PropTypes.bool,
  isValid: PropTypes.bool,
  isWarning: PropTypes.bool,
  isEmpty: PropTypes.bool,
  className: PropTypes.string,
  helpText: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool
};

export default inputComponent;
